import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography, Chip, CircularProgress, Grid, Divider } from '@mui/material';
import { api, type PaintProduct } from '../services/api';

export default function ProductCatalogPage() {
  const [products, setProducts] = useState<PaintProduct[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getPaintProducts().then(setProducts).finally(() => setLoading(false));
  }, []);

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}><CircularProgress sx={{ color: '#00AAFF' }} /></Box>;

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ color: '#F5F7FA', fontWeight: 'bold', mb: 3 }}>Paint Products</Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {products.map((p) => (
          <Card key={p.id} sx={{ bgcolor: '#121417', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 2 }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
                <Box>
                  <Typography sx={{ color: '#F5F7FA', fontWeight: 'bold', fontSize: 17 }}>{p.name}</Typography>
                  <Typography sx={{ color: '#6E7681', fontSize: 12 }}>{p.manufacturer}</Typography>
                </Box>
                {p.rating != null && (
                  <Typography sx={{ color: '#F5F7FA', fontWeight: 'bold', fontSize: 20 }}>
                    {p.rating.toFixed(1)}<Typography component="span" sx={{ color: '#6E7681', fontSize: 12 }}> /10</Typography>
                  </Typography>
                )}
              </Box>

              <Grid container spacing={1} sx={{ mb: 1.5 }}>
                <Grid item xs={6}>
                  <Typography sx={{ color: '#8A8F98', fontSize: 12 }}>
                    Lifespan: <Box component="span" sx={{ color: '#F5F7FA' }}>{p.lifespan_years}yr</Box>
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ color: '#8A8F98', fontSize: 12 }}>
                    Recoat: <Box component="span" sx={{ color: '#F5F7FA' }}>{p.recoat_years}yr</Box>
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ color: '#8A8F98', fontSize: 12 }}>
                    Coverage: <Box component="span" sx={{ color: '#F5F7FA' }}>{p.coverage_sqft_per_gal} SF</Box>
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ color: '#8A8F98', fontSize: 12 }}>
                    Cost: <Box component="span" sx={{ color: '#F5F7FA' }}>${p.cost_per_gal}/gal</Box>
                  </Typography>
                </Grid>
              </Grid>

              {p.surface_tags && p.surface_tags.length > 0 && (
                <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap', mb: 1.5 }}>
                  {p.surface_tags.map((tag) => (
                    <Chip key={tag} label={tag} size="small" sx={{ bgcolor: '#1D2126', color: '#8A8F98', fontSize: 11 }} />
                  ))}
                </Box>
              )}

              {p.description && (
                <>
                  <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)', mb: 1.5 }} />
                  <Typography sx={{ color: '#6E7681', fontSize: 13 }}>{p.description}</Typography>
                </>
              )}
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
}
